<template>
  <sidebar>
    <sidebar-link icon="briefcase" :caption="$t('sidebar.dashboard')" route="/dashboards" :broken="!loadedModules.frontend"/>
    <sidebar-link icon="analytics" :caption="$t('sidebar.cashflow')" route="/cash-flow" :broken="!loadedModules.cashflow"/>
    <sidebar-link icon="calculator" :caption="$t('sidebar.reporting')" route="/reporting"  />
    <sidebar-link icon="receipt" :caption="$t('sidebar.operations')" route="/operations" :broken="!loadedModules.operations"/>
    <sidebar-link icon="building" :caption="$t('sidebar.parties')" route="/parties" :broken="!loadedModules.parties"/>
    <sidebar-link icon="piggy-bank" :caption="$t('sidebar.banking')" route="/banking" :broken="!loadedModules.accounts"/>
<!--    <sidebar-link icon="wallet" caption="Payment factory" route="/payment-factory" :broken="!loadedModules.payments"/>-->
    <sidebar-link icon="globe" :caption="$t('sidebar.market')" route="/market" :broken="!loadedModules.currencies"/>


    <template slot="bottom">
      <sidebar-link icon="microchip" :caption="$t('sidebar.processing')" route="/processing" :badge="runningImportProcesses.length"/>
      <sidebar-link icon="tools" :caption="$t('sidebar.administration')" route="/administration"/>
      <sidebar-link icon="user" :caption="$t('sidebar.loggedInAs', {user: actualUser.username})"
                    route="/user-settings"/>

      <div class="sidebar-link" @click="logout" v-tooltip.right="$t('sidebar.logout')">
        <icon :icon="['far', 'sign-out']"/>
      </div>
    </template>
  </sidebar>
</template>

<script>
import Sidebar from "../components/navigation/Sidebar";
import {mapGetters} from "vuex";
import SidebarLink from "../components/SidebarLink";

export default {
  name: "SidebarView",
  components: {SidebarLink, Sidebar},
  data: function () {
    return {
      importProcessHandle: null
    }
  },
  props: {
    loadedModules: Object
  },
  computed: {
    ...mapGetters({
      operationDefinitions: "operationDefinitions/operationDefinitions",
      cashflowReports: "cashflowReportDefinitions/cashflowReportDefinitions",
      'runningImportProcesses': 'importProcesses/getRunningProcesses',
      'actualUser': 'auth/actualPrincipal'
    })
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/LOGOUT");
    }
  },
  destroyed() {
    clearInterval(this.importProcessHandle);
  },
  mounted() {
    this.importProcessHandle = setInterval(() => {
      this.$store.dispatch('importProcesses/refreshRunningImportProcesses')
    }, 10000)
  }
}
</script>

<style lang="scss" scoped>
.fa-icon {
  margin-right: 15px;
}

.user-icon {
  font-size: 15px;
  display: flex;
  width: calc(100% - 20px);
  height: 30px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: var(--accent-color);
  color: var(--input-active-font-color);
  border: 1px solid var(--input-active-font-color);
  margin: 10px;
  border-radius: 15px;
}

</style>